import React, { useEffect, useState } from 'react';
import { Card, CardBody, Input, Label, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "./ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import logoLight from "../../assets/images/logo-light.png";
import { createSelector } from 'reselect';

const Login = (props) => {
    const dispatch = useDispatch();
    const selectLayoutState = (state) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Account.user,
            error: state.Login.error,
            loading: state.Login.loading,
            errorMsg: state.Login.errorMsg,
        })
    );
    // Inside your component
    const {
        user, error, loading, errorMsg
    } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState([]);
    const [passwordShow, setPasswordShow] = useState(false);


    useEffect(() => {
        if (user && user) {
            const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.email : user.user.email;
            const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.user.confirm_password;
            setUserLogin({
                email: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email || userLogin.username || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Please Enter Valid Email").required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser(values, props.router.navigate));
        }
    });

    const signIn = type => {
        dispatch(socialLogin(type, props.router.navigate));
    };

    //handleTwitterLoginResponse
    // const twitterResponse = e => {}

    //for facebook and google authentication
    const socialResponse = type => {
        signIn(type);
    };


    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "Sign In | Precious Food";
    return (
        <React.Fragment>
            <ParticlesAuth>
                {/* Mobile-only branding (left panel hidden on small screens) */}
                <div className="d-lg-none text-center mb-4">
                    <Link to="/" className="d-inline-block">
                        <img src={logoLight} alt="Precious Food" style={{ height: "56px" }} />
                    </Link>
                    <p className="text-body-secondary small mt-2 mb-0 fw-medium">Precious Food</p>
                </div>

                <Card className="auth-login-card shadow-sm border-0 rounded-4 overflow-hidden">
                    <CardBody className="p-4 p-md-5">
                        <div className="mb-4">
                            <h2 className="h4 text-dark fw-bold mb-1">Welcome back</h2>
                            <p className="text-muted small mb-0">Sign in to your account to continue</p>
                        </div>

                        {errorMsg && (
                            <Alert color="danger" className="rounded-3 border-0 mb-4 py-2 small d-flex align-items-center">
                                <i className="ri-error-warning-line me-2" />
                                {errorMsg}
                            </Alert>
                        )}

                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                            action="#"
                        >
                            <div className="mb-3">
                                <Label htmlFor="email" className="form-label fw-medium text-body">Email address</Label>
                                <div className="input-group input-group-auth rounded-3">
                                    <span className="input-group-text bg-light border-end-0 rounded-start-3 border">
                                        <i className="ri-mail-line text-muted" />
                                    </span>
                                    <Input
                                        id="email"
                                        name="email"
                                        className="form-control border-start-0 rounded-end-3 bg-light py-2"
                                        placeholder="name@example.com"
                                        type="email"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.email || ""}
                                        invalid={validation.touched.email && validation.errors.email}
                                    />
                                </div>
                                {validation.touched.email && validation.errors.email && (
                                    <FormFeedback type="invalid" className="d-block small">{validation.errors.email}</FormFeedback>
                                )}
                            </div>

                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <Label htmlFor="password-input" className="form-label fw-medium text-body mb-0">Password</Label>
                                    <Link to="/forgot-password" className="text-primary text-decoration-none small fw-medium">Forgot password?</Link>
                                </div>
                                <div className="input-group input-group-auth rounded-3 position-relative auth-pass-inputgroup">
                                    <span className="input-group-text bg-light border-end-0 rounded-start-3 border">
                                        <i className="ri-lock-password-line text-muted" />
                                    </span>
                                    <Input
                                        id="password-input"
                                        name="password"
                                        value={validation.values.password || ""}
                                        type={passwordShow ? "text" : "password"}
                                        className="form-control border-start-0 rounded-end-3 bg-light py-2 pe-5"
                                        placeholder="Enter your password"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={validation.touched.password && validation.errors.password}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-muted text-decoration-none p-0 me-3"
                                        style={{ zIndex: 5 }}
                                        onClick={() => setPasswordShow(!passwordShow)}
                                        aria-label={passwordShow ? "Hide password" : "Show password"}
                                    >
                                        <i className={passwordShow ? "ri-eye-off-line" : "ri-eye-line"} />
                                    </button>
                                </div>
                                {validation.touched.password && validation.errors.password && (
                                    <FormFeedback type="invalid" className="d-block small">{validation.errors.password}</FormFeedback>
                                )}
                            </div>

                            <div className="form-check form-check-auth mb-4">
                                <Input className="form-check-input rounded" type="checkbox" id="auth-remember-check" />
                                <Label className="form-check-label small text-muted" htmlFor="auth-remember-check">Remember me for 30 days</Label>
                            </div>

                            <Button
                                disabled={loading}
                                color="success"
                                className="w-100 rounded-3 py-2 fw-semibold auth-login-btn"
                                type="submit"
                            >
                                {loading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Signing in...
                                    </>
                                ) : (
                                    "Sign in"
                                )}
                            </Button>
                        </Form>
                    </CardBody>
                </Card>

                <p className="text-center text-body-secondary small mt-4 mb-0">
                    Don&apos;t have an account? <span className="fw-medium">Contact your admin</span> for access.
                </p>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);